import { rgba as polishedRgba } from "polished"

import { theme } from "@/stitches/theme"

export const rgba = (color: keyof (typeof theme)["colors"], alpha = 1) =>
  polishedRgba(theme.colors[color], alpha)
